module.exports = __webpack_public_path__ + "img/loader.72ae33cc.gif";